import { useState, useEffect, useCallback } from 'react'
import { RequestService } from '../services/RequestService'

const usePVT = () => {
  const [data, setData] = useState(null)

  const fetchData = useCallback(async () => {
    try {
      const { data } = await RequestService.getPvtStatus()

      setData(data)
    } catch (e) {
      console.log('usePVT fetchData', e)
    }
  }, [])

  const startPVT = useCallback(async ({ device_model, device_os, is_mobile, is_tablet, is_desktop}) => {
    try {
      const { status, data } = await RequestService.pvtStarted({
        device_model,
        device_os,
        is_mobile,
        is_tablet,
        is_desktop
      })

      return { status, data }
    } catch (e) {
      console.log('usePVT', e)
    }
  }, [])

  useEffect(() => {
    fetchData()
  }, [])

  return { data, fetchData, startPVT }
}

export default usePVT
